<template>
    <div v-bind:class="'col-md-'+validConfig.col">  
        <div class="form-group">
        <label>{{ validConfig.holder }}:</label> <small class="word-counter" v-if="countArea && textLength>0 " ><b>{{ textLength }}</b></small>
            <div  class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text "> 
                         <i  v-if="isError.bool" class="fas fa-keyboard"></i>
                        <i  v-else v-on:click="isErrormsg(isError)" class="fa fa-exclamation-triangle text-danger skew-shake-y" style="cursor:pointer" ></i>
                    </span>
                </div>
                <textarea :id="validConfig.id" :value="modelValue ?? ''" @input="$emit('updateValue',($event!.target as HTMLInputElement)!.value,validConfig.name)"   class="form-control" v-bind:class="isError.class"  :placeholder="validConfig.holder" :rows="numRows"></textarea>      
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import {  reactive,toRefs,watchEffect,ref } from "vue";
    import validate from '@/core/composable/useValidate'
    import messages from '@/core/composable/useMessages'
    
    const { longitud } = validate();
    const { validateNotification } = messages();
           
    const props = defineProps<{
     modelValue  : string|null,
     validConfig : { value?: string | null, validate: boolean, name: string, message: string, col: number, min: number, max: number, empaty: number, holder: string, id: string }  
     countText ?: boolean,//[true]. the character counter is activated within the textArea
     rowsArea ?:number //[define true].number of rows for the text area by default 3
    }>()
   
    const emit = defineEmits<{
       (e: 'updateStatus', name: string,status:boolean): void
       (e: 'updateValue', value: string,name:string): void
    }>()

    const { validConfig, modelValue,countText,rowsArea} = toRefs(props);
    const textLength = ref(0);

    const countArea = countText.value !== undefined ? countText.value : true;
    const numRows = rowsArea.value !== undefined ? rowsArea.value : 3;


    let      isError = reactive({ validate: false, class: "", required: validConfig.value.message, bool: true }  );
    const isErrormsg = (dto: object) => { validateNotification(dto); }
    

    watchEffect(() => {
        isError = longitud(modelValue.value ?? '', validConfig.value.empaty, validConfig.value.min, validConfig.value.max, isError.required);
        if(isError.validate){  
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value?? '', validConfig.value.name  );
        }else{       
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value ?? '', validConfig.value.name  );   
        } 
    
    
        textLength.value = (modelValue.value ?? '').length;
    })
</script>
<style>
i.skew-shake-y {
  animation: skew-y-shake 1.3s infinite;
}

@keyframes skew-y-shake {
  0% { transform: skewY(-15deg); }
  5% { transform: skewY(15deg); }
  10% { transform: skewY(-15deg); }
  15% { transform: skewY(15deg); }
  20% { transform: skewY(0deg); }
  100% { transform: skewY(0deg); }  
}
</style>